import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  RootProvider,
  CallDashboardProvider,
  useCallDashboard,
} from '@accuhealth/call-dashboard-ui';
import { Routes } from 'router/routes';

const AWS_CONNECT_URL_CCP = process.env.REACT_APP_CONNECT_URL_CCP!;
const AWS_CONNECT_URL = process.env.REACT_APP_CONNECT_URL!;
const REACT_APP_CALL_DASHBOARD_API = process.env.REACT_APP_CALL_DASHBOARD_API!;

interface ICallDashboardOptionsProps {
  isDashboard: boolean;
  isMetrics: boolean;
  children: React.ReactNode;
}

const CallDashboardOptions: React.FC<ICallDashboardOptionsProps> = ({
  isDashboard,
  isMetrics,
  children,
}) => {
  const { contact, terminate, isInitialized } = useCallDashboard();

  const {
    connect: { setConnectCanCall },
  } = useDispatch();

  useEffect(() => {
    if (!isDashboard && !isMetrics && !contact && isInitialized) {
      terminate();
    }
  }, [isDashboard, isMetrics, contact, terminate]);

  useEffect(() => {
    setConnectCanCall(!contact);
  }, [contact]);

  return children;
};

interface IProps {
  children?: React.ReactNode;
}

const CallDashboardLayout: React.FC<IProps> = ({ children }) => {
  const location = useLocation();

  const isDashboard = location.pathname === Routes.callDashboard;
  const isMetrics = location.pathname === Routes.callAgentsDashboardActivity;

  return (
    <RootProvider apiUrl={REACT_APP_CALL_DASHBOARD_API}>
      <CallDashboardProvider
        containerId="aws-call-dashboard"
        loginUrl={AWS_CONNECT_URL}
        ccpUrl={AWS_CONNECT_URL_CCP}
        outpageShow={!isDashboard}
      >
        <CallDashboardOptions isDashboard={isDashboard} isMetrics={isMetrics}>
          {children}
        </CallDashboardOptions>
      </CallDashboardProvider>
    </RootProvider>
  );
};

export default CallDashboardLayout;
